module.exports = __webpack_public_path__ + "img/logo_blank.9fcfa1fe.png";